import store from "@/store";
import Vue from "vue";
// 提示信息
import { Message } from "element-ui";
// 拿取本地数据
import { saveRlData } from "@/mixins/LiteModuleDb.js";
import {
  saveModelAndroid,
  getUserInfo,
  isAndroidOnline,
} from "@/api/androidApi";
import CryptoJS from "crypto-js";
import { MessageBox } from "element-ui";
export function formatTimestamp(timestamp) {
  // 创建Date对象，处理秒级时间戳
  const date = new Date(
    timestamp.toString().length === 10 ? timestamp * 1000 : timestamp
  );

  // 获取各时间部分
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始，补0
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  // 组合成常用格式
  return {
    year,
    month,
    day,
    hours,
    minutes,
    seconds,
    ymd: `${year}-${month}-${day}`,
    hms: `${hours}:${minutes}:${seconds}`,
    full: `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`,
  };
}
// --- 计时器
export function startTimers(projectId, scene) {
  const intervalId1 = setInterval(() => {
    transferLocalData(projectId, scene);
  }, 1 * 60 * 1000); // 1分钟
  return { intervalId1 };
}

export function stopTimers({ intervalId1 }) {
  clearInterval(intervalId1);
}

// 绝对一致的序列化方法
function createCanonicalString(obj) {
  if (obj === null || obj === undefined) return "null";
  if (typeof obj === "number" || typeof obj === "boolean")
    return obj.toString();
  if (typeof obj === "string") return JSON.stringify(obj); // 处理字符串转义

  if (Array.isArray(obj)) {
    const items = obj.map((item) => createCanonicalString(item));
    return "[" + items.join(",") + "]";
  }

  if (typeof obj === "object") {
    // 按键名排序
    const sortedKeys = Object.keys(obj).sort();
    const keyValuePairs = sortedKeys.map((key) => {
      return JSON.stringify(key) + ":" + createCanonicalString(obj[key]);
    });
    return "{" + keyValuePairs.join(",") + "}";
  }

  return obj.toString();
}

function sendBuildingData(valueData) {
  // 生成规范字符串
  const canonicalString = createCanonicalString(valueData);
  const valueMd5 = CryptoJS.MD5(canonicalString).toString();
  return {
    valueMd5,
    canonicalString,
  };
}

// indexedDB
var idbTimer;
export function changeIdbTime(dateTime) {
  if (idbTimer === undefined) {
    idbTimer = dateTime;
  }
}
export function getIdbTime(dateTime) {
  return idbTimer;
}
// 拿到所有本地数据并传输
export async function transferLocalData(projectId, scene, manualSave) {
  try {
    console.log("保存数据ing", manualSave);
    const { value, timestamp } = await saveRlData();
    if (
      (!value ||
        !value.rlFloor ||
        value.rlFloor.length == 0 ||
        store.state.cadModules.lock) &&
      !isAndroidOnline() &&
      manualSave !== 2
    ) {
      console.log("数据不存在或者当前用户被锁住了");
      //提示用户刷新后重试
      // Message.warning("Indexdb数据为空，请刷新后重试!");
      return;
    }
    console.log("idbTimer", idbTimer, timestamp);
    // 如果当前时间戳和上次时间戳不同，则传输数据
    //manualSave 2为强制提交，这个是同类构件用
    if (idbTimer != timestamp || manualSave === 2) {
      // || manualSave !== undefined
      store.state.cadModules.isSaveLoading = true;
      idbTimer = timestamp;
      if (value.rlStdFlr.length === 0) {
        MessageBox.confirm(
          "识别到模型数据部分为空，是否要提交到线上?",
          "提示",
          {
            confirmButtonText: "直接提交",
            cancelButtonText: "刷新界面取最新数据",
            type: "warning",
          }
        )
          .then(async () => {
            const currentValue = JSON.parse(JSON.stringify(value));
            const buildData = sendBuildingData(value);
            const parameter = {
              projectId, // 项目ID
              scene, // 场景
              value: currentValue, // 传输的内容
              token: store.state.user.token,
              saveMethod: manualSave ? manualSave : 0, // 传输方式 0自动1手动
              ydb_push_time: formatTimestamp(Date.now()).full,
              value_md5: buildData.valueMd5,
              canonical_string: buildData.canonicalString,
            };
            let userInfo = {};
            if (process.env.VUE_APP_PC !== "true") {
              userInfo = getUserInfo();
            }
            // 安卓保存
            if (store.state.app.isAndroid) {
              await saveModelAndroid(parameter);
              console.log("android保存");
            } else {
              console.log("推送消息");
              // 传递给服务端（PHP）
              await Vue.prototype.$socketApi.sendSock({
                ...parameter,
              });
            }
            // 清空本地数据
            value.rlStdFlr = null;
            value.rlFloor = null;
            value.rlColSect = null;
            value.rlBeamSect = null;
            value.rlWallSect = null;
            value.rlSlabSect = null;
            value.rlRingBeamSect = null;
            value.rlWallHoleDef = null;
            value.rlSlabHoleDef = null;
            value.rlPartitionWallSect = null;
            value.rlDoorsWindowsDef = null;
            value.rlLayer = null;
            value.rlCantiSlabDef = null;
            return parameter;
          })
          .catch(() => {
            window.location.reload();
            // this.$message({
            //   type: "info",
            //   message: "已取消删除",
            // });
          });
        return;
      }
      const currentValue = JSON.parse(JSON.stringify(value));
      const buildData = sendBuildingData(value);
      const parameter = {
        projectId, // 项目ID
        scene, // 场景
        value: currentValue, // 传输的内容
        token: store.state.user.token,
        saveMethod: manualSave ? manualSave : 0, // 传输方式 0自动1手动
        ydb_push_time: formatTimestamp(Date.now()).full,
        value_md5: buildData.valueMd5,
        canonical_string: buildData.canonicalString,
      };
      // console.log("parameter", parameter);
      let userInfo = {};
      if (process.env.VUE_APP_PC !== "true") {
        userInfo = getUserInfo();
      }

      // 安卓保存
      if (store.state.app.isAndroid) {
        await saveModelAndroid(parameter);
        console.log("android保存");
      } else {
        console.log("推送消息");
        // 传递给服务端（PHP）
        await Vue.prototype.$socketApi.sendSock({
          ...parameter,
        });
      }
      // 清空本地数据
      value.rlStdFlr = null;
      value.rlFloor = null;
      value.rlColSect = null;
      value.rlBeamSect = null;
      value.rlWallSect = null;
      value.rlSlabSect = null;
      value.rlRingBeamSect = null;
      value.rlWallHoleDef = null;
      value.rlSlabHoleDef = null;
      value.rlPartitionWallSect = null;
      value.rlDoorsWindowsDef = null;
      value.rlLayer = null;
      value.rlCantiSlabDef = null;
      return parameter;
    } else {
      console.log("模型未变更，不推送任何数据");
    }
  } catch (error) {
    console.log("error", error);
  }
}

//服务器数据存储成功后会发送两条消息，一条是保存成功，一条是保存成功后的数据内容
export const receivedMsg = (data) => {
  if (data.message.msg == "收到" && data.message.saveMethod == 1) {
    Message.success("模型保存成功");
  }
};
